import React from 'react'
import {
	Drawer, Row, Typography, Space, Divider, Tag, Button
} from 'antd'
import {
	CloseOutlined, ClockCircleOutlined, BorderOutlined, ExclamationCircleOutlined, EditOutlined
} from '@ant-design/icons'
import { ICalculatedYearFinish } from '../../../reducers/payslips/actions'

interface YearFinishesDrawerProps {
	open: boolean
	onClose: () => void
	finishes: ICalculatedYearFinish[]
	onOpenJob?: (jobId: number) => void
}

const YearFinishesDrawer: React.FC<YearFinishesDrawerProps> = ({ open, onClose, finishes, onOpenJob }) => (
	<Drawer
		title={
			<Row justify="space-between" align="middle">
				<Space>
					<CloseOutlined style={{ color: '#aaa' }} onClick={onClose} />
					<Typography.Text strong>Ročné upratovania</Typography.Text>
				</Space>
			</Row>
		}
		width={800}
		visible={open}
		onClose={onClose}
		closeIcon={null}
	>
		{finishes.length === 0 && (
			<Typography.Text type="secondary">
				V tomto mesiaci sa neuskutočnili žiadne ročné upratovania.
			</Typography.Text>
		)}
		{finishes.map((finish) => (
			<div key={`${finish.jobId}-${finish.id}`} style={{ marginBottom: 16 }}>
				<Row justify="space-between" align="middle">
					<Typography.Text type="secondary">
						{finish.date} | {finish.frequency} | {finish.address}
					</Typography.Text>
					{onOpenJob && (
						<Button
							type="link"
							size="small"
							icon={<EditOutlined />}
							style={{ padding: 0 }}
							onClick={() => onOpenJob(finish.jobId)}
						>
							Otvoriť zákazku
						</Button>
					)}
				</Row>

				<Row gutter={16} style={{ marginTop: 8 }}>
					<Space size="large" wrap>
						{finish.missingWindowsError ? (
							<Tag icon={<ExclamationCircleOutlined />} color="red">
								<strong>Chýba počet okien</strong> – doplňte ho v zákazke
							</Tag>
						) : (
							<Tag icon={<BorderOutlined />} color="blue">
								<strong>Umyté okná:</strong> {finish.windows} (bonus {(finish.windows || 0).toFixed(2)} €)
							</Tag>
						)}
						<Tag icon={<ClockCircleOutlined />} color={finish.qrScans.from ? 'green' : 'red'}>
							<strong>Príchod:</strong> {finish.qrScans.from ?? '—'}
						</Tag>
						<Tag icon={<ClockCircleOutlined />} color={finish.qrScans.to ? 'green' : 'red'}>
							<strong>Odchod:</strong> {finish.qrScans.to ?? '—'}
						</Tag>
						<Tag color={finish.qrScans.to ? 'green' : 'red'}>
							<strong>Trvanie:</strong> {finish.qrScans.duration ?? '—'}
						</Tag>
					</Space>
				</Row>

				{finish.errorMessages.length > 0 && (
					<div style={{ marginTop: 8 }}>
						{finish.errorMessages.map((err, idx) => (
							<Typography.Text key={idx} type="danger" style={{ display: 'block' }}>
								{err}
							</Typography.Text>
						))}
					</div>
				)}

				<Divider style={{ marginTop: 16, marginBottom: 16 }} />
			</div>
		))}
	</Drawer>
)

export default YearFinishesDrawer
